module.exports = __webpack_public_path__ + "img/nav-back.3f28648e.png";